import React from 'react';
import '../pagelayout/global.scss';
import './tasksListHeader.scss';
import {COLUMNS} from './taskListSorting.function';
import {KEYS} from "utils/constants";
import Checkbox from "components/common/checkbox.component";
import { useTranslation } from 'components/translations/useTranslation';
import {Tooltip} from "components/tooltip/Tooltip";

const TaskListHeader = ({
                            currentSort,
                            sortByCallback,
                            selectAllCallback,
                            currentAllSelected,
                            displayedDate,
                            showLastChangedBy
                        }) => {

    /**
     * definition of all columns for myTasks (I don't want to put it into general constants
     * @return {[*,*,*,*]}
     */
    function getColumnDefinition(displayedDate, showLastChangedBy) {
        let columns = [
            {
                name: 'documentType', // will be used for picking proper translation .. also it's discriminator of column from taskListSorting
                align: 'center', // css
                size: 'document-type-column', // css
                px: 'px-0'
            },
            {
                name: 'supplierName',
                align: 'start',
                size: 'supplier-name-column',
                px: 'px-0'
            },
            {
                name: 'description',
                align: 'start',
                size: "description-column",
                px: 'px-0'
            }
        ];

        columns.push(
            {
                name: 'companyName',
                align: 'start',
                size: 'company-name-column',
                px: 'px-0'
            }
        );
        columns.push(
            {
                name: displayedDate,
                align: 'start',
                size: 'document-due-column',
                px: 'px-0'
            }
        );
        columns.push(
            {
                name: 'amount',
                align: 'end',
                size: 'amount-column',
                px: 'px-0'
            }
        );

        if (showLastChangedBy) {
            columns.push(
                {
                    name: 'lastChangedBy',
                    align: 'start',
                    size: 'last-changed-by-column',
                    px: 'px-4'
                }
            );
        }

        columns.push(
            {
                name: 'numberOfComments',
                align: 'center',
                size: 'comments-column',
                px: 'px-0'
            }
        );

        return columns;
    }
    const { translate } = useTranslation();
    const columns = getColumnDefinition(displayedDate, showLastChangedBy);

    let columnsView = columns.map((column, index) => {
            const alignClass = column.size + " header-column " + column.px + " d-flex justify-content-" + column.align;
            const sortIcon = <span className={"sort-arrow sort-arrow-" + (currentSort < 0 ? "up" : "down")}/>;
            const columnId = COLUMNS[column.name];
            const current = Math.abs(columnId) === Math.abs(currentSort);
            const hasTooltip = column.name === displayedDate;

            return (
                <li key={columnId + "_" + column.name} className={alignClass} onClick={() => {
                    if (current) sortByCallback(-1 * currentSort);
                    else sortByCallback(columnId);
                }}>
                    <span className="caption"
                          data-tip={hasTooltip ? "" : undefined}
                          data-for={hasTooltip ? "task-column-tooltip-" + column.name : undefined}>{translate("myTasks.column." + column.name)}
                        {hasTooltip &&
                            <Tooltip id={"task-column-tooltip-" + column.name}
                                     content={() => translate("myTasks.selectDate." + displayedDate)}/>}
                    </span>
                    {current && sortIcon}
                </li>
            )
        }
    );

    let handleKeyDown = function (event) {
        if (event.keyCode === KEYS.ENTER) {
            event.preventDefault();
            selectAllCallback();
        }
    }

    const selectAll = (event) => {
        event.stopPropagation();
        selectAllCallback();
    }

    return (
        <ul className="list-unstyled row px-0 mx-0 d-flex flex-row justify-content-between">
            <li className="task-checkbox ps-2" key="checkbox_1">
                <Checkbox
                    inputId={"task-checkbox-allTasks"}
                    onChange={selectAll} onKeyDown={handleKeyDown}
                    isChecked={currentAllSelected}
                    ariaLabel={translate("myTasks.selectAllTasks")}
                />
            </li>
            {columnsView}
            <li className="text-end px-0 float-right task-actions">
                <div className="caption">{translate("myTasks.column.action")}</div>
            </li>
        </ul>
    );

};

export default TaskListHeader;